import React, { Component } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SubtitleTimelineArea from './SubtitleTimelineArea';
import SubtitleTimelineAreaScroll from './SubtitleTimelineAreaScroll';
import SubtitleTimelineZoom from './SubtitleTimelineZoom';

import SubtitleActions from '../SubtitleActions';
import SubtitleService from '../SubtitleService';

@inject((stores) => ({
  duration: stores.SubtitleStore.duration,
  referenceLinePosition: stores.SubtitleStore.referenceLinePosition
}))
@observer
class SubtitleTimeline extends Component {
  timelineArea = React.createRef();

  static propTypes = {
    cues: PropTypes.object,
    duration: PropTypes.number,
    referenceLinePosition: PropTypes.number
  };

  render() {
    const { duration } = this.props;

    const width = SubtitleService.convertSecondsToBasePixels(duration);

    return (
      <div className="subtitle__timeline">
        <div className="subtitle__timeline__header">
          <Button
            className="subtitle__timeline__header__add"
            transparent
            onClick={this.addNewCue}
          >
            <I18n label="player_subtitles.add_new_subtitle" />
          </Button>

          <SubtitleTimelineZoom
            onZoomIn={SubtitleActions.increaseZoom}
            onZoomOut={SubtitleActions.decreaseZoom}
          />
        </div>

        <SubtitleTimelineArea ref={this.timelineArea} width={width} />
        <SubtitleTimelineAreaScroll timelineWidth={width} />
      </div>
    );
  }

  addNewCue = () => {
    const startTime = this.getReferenceLineTimePosition();

    SubtitleActions.addCue(startTime);
  };

  getReferenceLineTimePosition() {
    const { referenceLinePosition } = this.props;

    const timeCuesWidth = this.timelineArea.current.offsetWidth;
    const scrollLeft = this.timelineArea.current.scrollLeft;

    const timeCuesPosition = referenceLinePosition * timeCuesWidth;
    const mousePosition = scrollLeft + timeCuesPosition;

    return SubtitleService.convertBasePixelsToSeconds(mousePosition);
  }
}

export default SubtitleTimeline;
